export default {
  common_button_back: 'Takaisin',
  common_button_cancel: 'Peruuta',
  common_button_next: 'Seuraava',
  common_button_no: 'Ei',
  common_button_ok: 'OK',
  common_button_reset: 'Reset',
  common_button_skip: 'Ohita',
  common_button_yes: 'Kyllä',
  common_deactivated_message:
    'This kiosk has been activated on another device and is thus no longer active on this one. Please log in again. Thank you!',
  common_deactivated_title: 'Kiosk deactivated on this device',
  common_enterEmail_email: 'Anna työsähköpostiosoitteesi',
  common_enterEmail_title: 'Sähköpostiosoite',
  common_error_message_cameraNotAllowed: 'Tämä toiminto edellyttää pääsyä kameraan.',
  common_error_message_ForbiddenException: 'Riittämättömät oikeudet',
  common_error_message_incorrectEmail: 'Anna oikea sähköpostiosoite',
  common_error_message_invalidCredentials: 'Oho! Väärä käyttäjänimi ja/tai salasana. Yritä uudelleen',
  common_error_message_invalidMobile: 'Please enter a valid mobile phone number',
  common_error_message_missingField: 'Pakollinen kohta',
  common_error_message_noInternetConnection: 'Internetyhteys katkesi. Yritä uudelleen.',
  common_error_message_unauthorizedAccess: 'Ei pääsylupaa',
  common_error_message_webServiceWrongConnection: 'Virhe tiedonsiirrossa. Yritä uudelleen',
  common_error_title: 'Virhe',
  common_expired_message:
    'Either your trial has expired or the credit card we have on file stopped working. Please upgrade in order to re-activate the account. Contact sales@proxyclick.com if you have any questions. Thank you!',
  common_expired_title: 'Account expired',
  common_onboarding_login_button: 'Log in',
  common_onboarding_message1: 'Proxyclick helps you singleTenantWelcome your visitors exactly the way you want to.',
  common_onboarding_message2:
    'Brand your check-in process and your badges, and ask your visitors only the questions that apply to them.',
  common_onboarding_message3: 'Hosts get notified when their guests arrive and can reply instantly.',
  common_onboarding_message4:
    'Protect your facilities and ensure compliance through emergency lists, watch lists, NDAs, privacy rules ...',
  common_onboarding_message5:
    'Proxyclick does the hard work so you can singleTenantWelcome your visitors with a smile.',
  common_placeholder_optional: 'Valinnainen',
  common_setup_activationCode_activate_button: 'Activate',
  common_setup_activationCode_code: 'Enter your activation code',
  common_setup_activationCode_code_placeholder: 'Eg. YSSFG-CVWVR-JFRWX-HSNMK',
  common_setup_activationCode_error_invalidCode: 'Invalid activation code',
  common_setup_activationCode_footer: 'Activation code is handy for SSO admins or for local guards. Learn More.',
  common_setup_activationCode_title: 'Activate kiosk with unique code',
  common_setup_device_footer: 'Luo uusi kioski yhdistämällä Proxyclick-verkkosovellukseen',
  common_setup_device_locked_content:
    'Tämä kioski on jo käytössä toisella iPadilla. Jos otat kioskin käyttöön iPadilla, joka sinulla on nyt käsissäsi, se deaktivoituu toisella iPadilla. Haluatko varmasti ottaa kioskin käyttöön tällä iPadilla?',
  common_setup_device_locked_continue_button: 'Ota tämä kioski käyttöön',
  common_setup_device_locked_title: 'Kioski on jo käytössä',
  common_setup_device_multiTenants: 'Useampi yritys',
  common_setup_device_title: 'Valitse kioskisi',
  common_setup_loading_footer: 'Mukauta kioskiasi yhdistämällä Proxyclick-verkkosovellukseen',
  common_setup_loading_message: 'Määritetään...',
  common_setup_loading_title: 'Kioskiasi otetaan käyttöön...',
  common_setup_location_footer: 'Luo uusi sivusto yhdistämällä Proxyclick-verkkosovellukseen',
  common_setup_location_kiosk: 'kioski',
  common_setup_location_kiosks: 'kioskit',
  common_setup_location_title: 'Valitse sivustosi',
  common_setup_login_activationCode_button: 'Activate with unique code?',
  common_setup_login_email: 'Sähköposti',
  common_setup_login_forgotPassword_button: 'Unohditko salasanasi?',
  common_setup_login_password: 'Salasana',
  common_setup_login_title: 'Kirjaudu sisään Proxyclick-tililläsi',
  common_setup_ready_header: 'Oletko valmis ottamaan tämän iPadin käyttöön yrityksen {0} kioskina?',
  common_setup_ready_message: 'Käyttöönotto kestää vain hetken, ja sen jälkeen kioski on toiminnassa',
  common_setup_ready_setup_button: 'Ota käyttöön',
  common_setup_ready_title: 'Hei, {0}',
  common_signup_company: 'Yritys',
  common_signup_email: 'Sähköposti',
  common_signup_error_name: 'Anna etu- ja sukunimi',
  common_signup_loading_message1:
    'Voit mukauttaa kioskiasi yhdistämällä Proxyclick-verkkosovellukseen. Lähetimme juuri sähköpostitse kaikki tiedot.',
  common_signup_loading_message2:
    'Verkkosivulta voit määrittää tulostimesi niin, että vierailulupia voi tulostaa sisäänkirjautumisen yhteydessä.',
  common_signup_loading_message3:
    'Voit myös ottaa käyttöön ilmoitukset, jotka lähetetään vastaanottajalle sisäänkirjautumisen yhteydessä.',
  common_signup_loading_message4: 'Ja mukauttaa kioskia omilla väreillä ja tervehdyskuvalla.',
  common_signup_loading_title: 'Luodaan tiliä...',
  common_signup_name: 'Nimi',
  common_signup_name_placeholder: 'Etunimi Sukunimi',
  common_signup_password: 'Salasana',
  common_signup_title: 'Tervetuloa Proxyclickiin',
  common_signup_tryFree_button: 'Lähetä',
  common_timeout_content: 'Keskeytä koskettamalla',
  common_timeout_title: 'Palataan alkuun',
  common_tooltip_disable_button: 'Poista käytöstä kaikki vinkit',
  common_tooltip_gotIt_button: 'Selvä',
  dm_delivery_confirmation_knownRecipient: '{{Host_Name}} -palvelulle on ilmoitettu, että toimitit paketin',
  dm_delivery_confirmation_title: 'Kiitos!',
  dm_delivery_confirmation_unknownRecipient:
    '{{Company_Name}} -yritykselle on lähetetty ilmoitus siitä, että olet toimittanut heille paketin',
  dm_delivery_recipient_name: 'Kenelle tämä paketti on?',
  dm_delivery_recipient_unknown_button: 'En tiedä',
  em_multiTenant_alreadyRegistered_button: 'Tap here if you are an employee or have received a QR code to check in',
  em_multiTenant_notRegistered_button: 'Tap here to check in manually',
  vm_checkin_approval_confirmation_unregistered_message:
    'We are unable to check you in at this time. Please contact your host or reach out the reception for assistance.',
  vm_checkin_approval_confirmation_unregistered_title: 'Welcome {{Visitor_FirstName}} {{Visitor_LastName}}',
  vm_checkin_approval_notapproved_message:
    'We are unable to finalize your check-in at this time. Please contact your host or reach out to reception for assistance.',
  vm_checkin_approval_notapproved_title: 'Dear {{Visitor_FirstName}} {{Visitor_LastName}}',
  vm_checkin_confirmation_header_withoutPrint: 'Sinut on rekisteröity!',
  vm_checkin_confirmation_header_withPrint: 'Vierailulupaasi tulostetaan',
  vm_checkin_confirmation_message: 'Istu odottamaan, {{Host_FirstName}} saapuu pian luoksesi',
  vm_checkin_confirmation_takeBackID: "Please don't forget your ID",
  vm_checkin_confirmation_title: 'Kiitos!',
  vm_checkin_details_companyName: 'Yritys',
  vm_checkin_details_email: 'Sähköposti',
  vm_checkin_details_firstname: 'Etunimi',
  vm_checkin_details_lastname: 'Sukunimi',
  vm_checkin_details_title: 'Please enter your details',
  vm_checkin_error_message_unableToCheckIn:
    'Sisäänkirjautumisen viimeistelyssä tapahtui virhe, ota yhteyttä aulan henkilökuntaan',
  vm_checkin_flow_company: 'Yritys',
  vm_checkin_flow_duration: 'Visit duration',
  vm_checkin_flow_email: 'Sähköposti',
  vm_checkin_flow_error_message_imageNotAvailable:
    'Oho, kuva ei ole saatavilla tällä hetlellä (ongelma internetyhteydessä)',
  vm_checkin_flow_licensePlate: 'Rekisterikilpi',
  vm_checkin_flow_mobile: 'Anna matkapuhelinnumerosi',
  vm_checkin_flow_mobile_info: 'Tätä käytetään ottamaan sinuun yhteyttä hätätilanteessa, kun olet laitoksella',
  vm_checkin_flow_tooltip_content:
    'Kysy vierailijoiltasi mitä tahansa parantaaksesi heidän kokemustaan tai tehdäksesi sisäänkirjautumisesta turvallisempaa. Voit muuttaa kysymysten etenemistä vierailijoiden vastauksista riippuen. Näkemäsi kysymykset ovat vain esittelyn esimerkkejä.',
  vm_checkin_flow_tooltip_title: 'Fiksut kysymykset',
  vm_checkin_host_enterFullName: 'Anna vastaanottajasi koko nimi',
  vm_checkin_host_name: 'Kuka on vastaanottohenkilösi?',
  vm_checkin_host_notListed_block:
    'Jos et tiedä vastaanottajasi nimeä tai häntä ei löydy listalta, ota yhteys aulan henkilökuntaan',
  vm_checkin_host_notListed_continue: 'Ei listalla',
  vm_checkin_host_tooltip_content:
    'Kirjoita nimesi tähän, niin lähetämme sinulle sähköposti-ilmoituksen, jonka työntekijäsi saavat vierailijoiden saapuessa.',
  vm_checkin_host_tooltip_title: 'Vierailijan saapumisilmoitus',
  vm_checkin_host_unknown_button: 'En tiedä',
  vm_checkin_idScan_aila_footer: 'This screen is skipped when you use the recommended hardware ({0})',
  vm_checkin_idScan_aila_header: 'Please scan your ID',
  vm_checkin_idScan_aila_learnMore: 'Learn more',
  vm_checkin_idScan_aila_scan_button: 'Scan ID',
  vm_checkin_idScan_back_picture_header_aila: 'Place your ID in the holder so the back faces the camera.',
  vm_checkin_idScan_back_picture_header_noAila: 'Position the back of your ID entirely inside the frame.',
  vm_checkin_idScan_back_picture_take_button: 'Scan back',
  vm_checkin_idScan_cancel_message: 'Check-in will be cancelled and you will return to home screen',
  vm_checkin_idScan_cancel_title: 'Warning',
  vm_checkin_idScan_disclaimer_start_button: "Let's get started",
  vm_checkin_idScan_disclaimer_text:
    'As part of our security policy, we need to verify your identity using your ID. \n\nWe value your privacy, so we will not store the picture of your ID. Reception officers are available to help if you have any questions.',
  vm_checkin_idScan_editName_title: 'Please fill in your first and last name',
  vm_checkin_idScan_front_picture_header_aila: 'Place your ID in the holder so the front faces the camera.',
  vm_checkin_idScan_front_picture_header_noAila: 'Position your ID entirely inside the frame.',
  vm_checkin_idScan_front_picture_take_button: 'Scan front',
  vm_checkin_idScan_match_check: 'Comparing the two pictures',
  vm_checkin_idScan_match_confirm_button: 'Confirm',
  vm_checkin_idScan_match_error_default_header: 'Sorry, something went wrong.',
  vm_checkin_idScan_match_error_default_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_match_error_idExpired_header: 'Sorry, your ID seems to have expired.',
  vm_checkin_idScan_match_error_idExpired_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_match_error_idNoFace_header: 'Sorry, we could not identify a face on your ID.',
  vm_checkin_idScan_match_error_idNoFace_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_match_error_pictureNoFace_header: 'Sorry, we could not identify a face on the picture you took.',
  vm_checkin_idScan_match_error_pictureNoFace_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_region_0: ' United States',
  vm_checkin_idScan_region_1: ' Canada',
  vm_checkin_idScan_region_2: 'South America',
  vm_checkin_idScan_region_3: ' Europe',
  vm_checkin_idScan_region_4: ' Australia',
  vm_checkin_idScan_region_5: ' Asia',
  vm_checkin_idScan_region_6: ' General Documents',
  vm_checkin_idScan_region_7: ' Africa',
  vm_checkin_idScan_region_header: 'What region does your ID come from?',
  vm_checkin_instructions_agreeTerms_button: 'Hyväksyn',
  vm_checkin_instructions_clearSignature_button: 'Pyyhi',
  vm_checkin_instructions_sendCopy_button: 'Lähetä minulle kopio sähköpostitse',
  vm_checkin_instructions_sendCopyTo_button: 'Kopio lähetetään osoitteeseen {0} (vaihda)',
  vm_checkin_instructions_sign: 'Allekirjoita tähän sormellasi',
  vm_checkin_instructions_tooltip_content:
    'Vierailijasi voivat hyväksyä vierailun säännöt simppelisti napauttamalla tai allekirjoituksella. Voit muuttaa ehtojasi sisäänkirjautuvan vierailijan tyypistä riippuen. Mukauta tätä ja monia muita toimintoja Proxyclickin käyttöliittymässä.',
  vm_checkin_instructions_tooltip_title: 'Allekirjoitettu ja sinetöity',
  vm_checkin_method_name: 'Hei, mikä nimesi on?',
  vm_checkin_method_name_enterFullName: 'Anna koko nimesi',
  vm_checkin_method_name_invitationQuestion: 'Did you receive an invitation with a QR-code?',
  vm_checkin_method_name_notRegistered_block: 'Etkö ole listalla? Kirjaudu sisään vastaanotossa',
  vm_checkin_method_name_notRegistered_continue: 'Etkö ole listalla?',
  vm_checkin_method_tooltip_content:
    'Kirjaudu sisään nimellä Justin Diaz, niin näet, kuinka palaavat tai esirekisteröidyt vierailijat tunnistetaan.\n\nVoit myös kokeilla satunnaista nimeä nähdäksesi, miten odottamattomat vierailijat otetaan vastaan.',
  vm_checkin_method_tooltip_title: 'Vierailijan tunnistus',
  vm_checkin_picture_auto_countDown: ' ',
  vm_checkin_picture_auto_lookCamera: 'Please look at the camera, we will take your visitor picture',
  vm_checkin_picture_auto_pictureTaken: 'Picture taken',
  vm_checkin_picture_auto_stayStill: 'Remain still',
  vm_checkin_picture_take_button: 'Ota kuva',
  vm_checkin_picture_title: 'Otetaan sinusta kuva!',
  vm_checkin_picture_tooltip_content:
    'Voit räätälöidä kioskin tarpeidesi mukaan ja lisätä tai poistaa helposti toimintoja, kuten vierailijoiden kuvaamisen tai kulkulupien tulostuksen.',
  vm_checkin_picture_tooltip_title: 'Valinnaiset toiminnot',
  vm_checkin_qrcode_no_checkin_allowed: 'Checkin not allowed. Please contact the reception for assistance.',
  vm_checkin_returning_email: "Hello, what's your email address?",
  vm_checkin_returning_email_notRegistered:
    'We could not find a scheduled visit linked to your email address. Please check with reception or try again with a different email address.',
  vm_checkin_saveInfo_email: 'Save my info to speed up my next check-in',
  vm_checkin_saveInfo_email_placeholder: 'Enter your email address',
  vm_checkin_saveInfo_title: 'Enter your email',
  vm_checkin_summary_agreementAlreadySigned: 'Agreement already signed',
  vm_checkin_summary_checkin_button: 'Sisäänkirjaus',
  vm_checkin_summary_countDown: 'You will be checked in after',
  vm_checkin_summary_editDetails_button: 'Muokkaa tietoja',
  vm_checkin_summary_groupStats: 'Paikalla on jo {0}/{1} henkilöä',
  vm_checkin_summary_meetingTime: 'Tapaaminen – {0}',
  vm_checkin_summary_reviewDetails_button: 'Näytä vierailuni tiedot',
  vm_checkin_summary_sendPass_button: 'Lähetä älypuhelimeeni kulkulupa tulevia vierailuja varten',
  vm_checkin_summary_sendPassTo_button: 'Pysyvä kulkulupa lähetetään osoitteeseen {0} (vaihda)',
  vm_checkin_summary_takeNewPicture_button: 'Ota uusi kuva',
  vm_checkin_summary_title: 'Vierailusi ({{Company_Name}})',
  vm_checkin_summary_visiting: 'Vierailulla – {0}',
  vm_checkin_video_duration: 'Duration',
  vm_checkin_video_subtitle: 'Watch the full video to continue your check-in.',
  vm_checkin_welcome_firstTime: 'Tervetuloa, {{Visitor_FirstName}}!',
  vm_checkin_welcome_lastVisit_date: 'Your last visit was on {0}',
  vm_checkin_welcome_lastVisit_today: 'Your last visit was earlier today',
  vm_checkin_welcome_lastVisit_yesterday: 'Your last visit was yesterday',
  vm_checkin_welcome_returning: 'Tervetuloa takaisin, {{Visitor_FirstName}}!',
  vm_checkout_confirmation_header: 'Näkemiin, {{Visitor_FirstName}}!',
  vm_checkout_confirmation_message: 'Sinut on kirjattu ulos. Toivottavasti pidit vierailusta.',
  vm_checkout_confirmation_title: 'Kiitos vierailusta!',
  vm_checkout_method_name: 'Anna nimesi kassalle',
  vm_checkout_method_name_notFound: 'Ei löydy',
  vm_checkout_method_title: 'Kirjaudutaan ulos',
  vm_identification_id_button: 'Skannaa henkilötodistus',
  vm_identification_qrCode_button: 'Skannaa kutsu/kulkulupa',
  vm_infopack_confirmation: 'Kiitos!\nLähetimme tietoa osoitteeseen {0}.',
  vm_infopack_email: 'Anna sähköpostiosoitteesi, niin lähetämme sinulle tietoa Proxyclickistä',
  vm_infopack_likeCheckIn: 'Liked this check-in? Tap here to learn more',
  vm_infopack_likeProcess: 'Liked this process? Tap here to learn more',
  vm_infopack_send_button: 'Lähettäkää tietoa',
  vm_multiTenant_title: 'Tervetuloa, missä yrityksessä olet vierailulla?',
  vm_product_footer_learnMore: 'Learn more',
  vm_product_footer_noPartner: "You're using Proxyclick Welcome",
  vm_product_footer_partner: "You're using Proxyclick Welcome, brought to you by {0}",
  vm_qrCode_help: 'Pidä koodia 10–15 cm:n etäisyydellä kamerasta',
  vm_qrCode_not_recognized: 'Koodia ei tunnistettu',
  vm_qrCode_title: 'Skannaa vierailulupa tai Passbook-koodi',
  vm_signup_defaultInstruction_content:
    '<p style="text-align: center;"><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-wearbadge.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-assemblypoint.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-nopic.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-nosmoke.png" width="50"/><br/></p><h1>VIERAILIJAN OHJEET JA SALASSAPITOSOPIMUS</h1><p>{{Company_Name}} toivottaa sinut lämpimästi tervetulleeksi tiloihinsa.</p><h2>Terveys- ja turvaohjeet</h2><p>Huolehdimme terveydestäsi käyntisi aikana ja pyydämme, että noudatat seuraavia ohjeita:</p><ul><li><b>Pääsy tiloihin</b> sallitaan vain, kun {{Company_Name}} on myöntänyt työntekijän mukaasi</li><li><b>Vierailulupa</b> on oltava esillä kaikkina aikoina ja palautettava vastaanottoon lähdön yhteydessä</li><li><b>Hätätilanteissa</b> kaikkien vierailijoiden on poistuttava tiloista välittömästi lähimmän turvallisen uloskäynnin kautta ja siirryttävä lähimmälle kokoontumispaikalle</li><li>Vierailijoilla <b>kielletään ottamasta tallenteita</b> (valokvuia ja videoita) mistään sisätiloissa tai alueen ympäristössä</li><li><b>Tupakointi on ehdottomasti kiellettyä</b> rakennuksen sisätiloissa</li></ul><h2>Salassapitosopimus</h2><p>Kun {{Company_Name}} on päästänyt sinut tiloihinsa, olet saattanut saada tietoosi yksityisiä tietoja (esimerkiksi tietoa liittyen teknologiaan, prosesseihin, välineistöön, piirustuksiin ja tekniseen puoleen), joka ei ole yleisesti yleisön tiedossa (tästä eteenpäin kutsuttuna &#34;Luottamukselliseksi tiedoksi&#34;).</p><p>Kun {{Company_Name}} on antanut sinulle luvan vierailla tiloissaan ja asioida siellä, hyväksyt, ettet;</p><p>(a) Luovuta tai muulla tavalla jaa muille Luottamuksellista tietoa, jonka olet saanut tietoosi tällä tai muulla käynnilläsi; tai</p><p>(b) Kehitä, käytä tai auta muita käyttämään Luottamuksellista tietoa millään tavalla.</p><p>(c) Käytä kameroita tai videoteknologiaa paljastaaksesi Luottamuksellista tietoa.</p><p>Kirjautumalla yrityksen tiloihin hyväksyt ja ymmärrät Terveys- ja turvaohjeet sekä Salassapitosopimuksen.</p>',
  vm_signup_defaultInstruction_name: 'Kaikkien vierailijoiden allekirjoitettavat ohjeet',
  vm_signup_defaultInstruction_title: 'Lue ja allekirjoita alla',
  vm_vaccine_certification_accessDenied_button: 'Okay',
  vm_vaccine_certification_accessDenied_message:
    "Sorry you don't meet the vaccination requirements to enter the premisses",
  vm_vaccine_certification_accessDenied_title: 'Access has been denied',
  vm_vaccine_certification_declare_question_title:
    'Dear visitor, please declare whether you have a valid COVID vaccine certificate or a COVID test with a negative result',
  vm_vaccine_certification_intro_question_title: 'Dear visitor, do you have an EU COVID Vaccine Certificate?',
  vm_vaccine_certification_scanner_donthaveaqrcode: "I don't have a QR code",
  vm_vaccine_certification_scanner_subtitle:
    'Make sure that your QR code is enlarged and the brightness of your mobile phone is on maximum.',
  vm_vaccine_certification_scanner_title: 'Please present the QR code of your EU COVID certificate to the camera',
  vm_welcome_changeLanguage_button: 'Change Language',
  vm_welcome_checkin_button: 'Sisäänkirjaus',
  vm_welcome_checkout_button: 'Kirjaudu ulos',
  vm_welcome_delivery_button: 'Delivery',
  vm_welcome_hello_line1: 'Hei,',
  vm_welcome_hello_line2: 'kirjaudu sisään',
  vm_welcome_qrCode_checkedIn: "Welcome {0}, don't forget to check out before leaving",
  vm_welcome_qrCode_checkedOut: 'Thank you for visiting, {0}!',
  vm_welcome_qrCode_notRecognized: 'This QR code is not recognized. Please try again.',
  vm_welcome_qrCode_scan: 'Pre-registered Visitors: hold your QR code up to the camera for check-in or out',
  vm_welcome_qrCode_show: 'Employees: scan this QR code with Proovr to check in or check out',
  vm_welcome_qrCode_wrongCompany: 'Your QR code is invalid for this location.',
  vm_welcome_returning_button: 'Been here before?',
  vm_welcome_title: '{{Company_Name}} toivottaa sinut tervetulleeksi',
  vm_welcome_tooltip_content:
    'Personalisoi kioskisi kirjautumalla Proxyclick-verkkosovellukseen. Lähetimme juuri sähköpostitse ohjeet. Verkkosovelluksessa voit lähettää oman logosi ja taustakuvasi tai valita värin tehdäksesi kioskista brändiin sopivan.',
  vm_welcome_tooltip_title: 'Tee siitä omasi',
  vm_welcome_touchless_employee_qrCode_show: 'Scan this QR code with Proovr to check in as an employee',
  vm_welcome_touchless_qrCode_show: 'Unregistered Visitors: Scan this QR code for touchless check-in',
  vm_welcome_touchless_unexpected_and_employee_qrCode_show:
    'Scan this QR code with Proovr (employees) or your phone (visitors) to check in',
  vm_welcome_touchless_unexpected_qrCode_show: 'Scan this QR code with your phone to check in as a visitor',
  common_or: 'tai',
};
